import { put, call } from 'redux-saga/effects';
import * as actions from '../actions';
import { fetchConsents } from '../../api/application';

export function* getConsentsSaga(action) {
    try {
        const response = yield call(fetchConsents, action.clientId, action.productId, action.sessionId);
        yield put({ type: actions.onGetConsentsSuccess(response.data.data) });
    } catch (error) {
        yield put({ type: actions.onGetConsentsFailed(error.response.data) });
    }
}
